// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1CHoP","scrolled":"Header_scrolled__UKpET","buttons":"Header_buttons__2DpJA","logo":"Header_logo__2RGTh"};